<svg class="{{ classes() }}" viewBox="0 0 32 32" fill="none">
  <circle cx="16" cy="16" r="14" stroke="var(--bg-tertiary)" stroke-width="4" />
  <circle
    cx="16"
    cy="16"
    r="14"
    fill="none"
    stroke="var(--spinner-color)"
    stroke-width="4"
    stroke-dashoffset="75"
    stroke-dasharray="100"
    stroke-linecap="round"
  />
</svg>
